/* eslint-disable */

import { GetApp } from '@material-ui/icons'
import axios from 'axios'
import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import theme from '../../utils/theme'
import AlertMini from '../AlertMini'
import Link from '../Link/Link'
import Tooltip from '../Tooltip'

const ExportLink = styled(Link)`
  display: inline-flex;
  color: ${`var(--gameday-paging-csvExportColor, ${theme.paging.csvExportColor})`};
  margin-left: 0.3rem;

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.7;
      pointer-events: none;
    `}
`

const StyledIconContainer = styled.span`
  height: 2.25rem;
  margin-top: -0.3rem;
  margin-right: 0.5rem;
`

const ExportIcon = styled(GetApp)`
  height: 100%;
  && {
    font-size: 24px;
  }
`

const ExportTableData = ({ exportFileName, exportDataUrl, orgId, contactId, eventNumber }) => {
  const [exportDisabled, setExportDisabled] = useState(false)
  const [alert, setAlert] = useState({
    open: false,
    title: '',
    text: '',
    variant: '',
  })

  useEffect(() => {
    if (exportDisabled) {
      const timer = setTimeout(() => {
        setExportDisabled(false)
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [exportDisabled])

  useEffect(() => {
    return () => {
      setExportDisabled(false)
      setAlert({
        open: false,
        title: '',
        text: '',
        variant: '',
      })
    }
  }, [])

  const exportData = () => {
    setExportDisabled(true)
    const paramsOnly = (exportDataUrl || '?').split('?')[1]
    const queryParams = new URLSearchParams(paramsOnly)
    const organisationId = queryParams.get('organisationId')
    const page = queryParams.get('page')
    const size = queryParams.get('size')
    const q = queryParams.get('q')
    const gender = queryParams.get('gender')
    const genderIdentity = queryParams.get('genderIdentity')
    const memberStatus = queryParams.get('status')
    const teamStatus = queryParams.get('status')
    const org = queryParams.get('org')
    const product = queryParams.get('product')
    const productId = queryParams.get('productId')
    const type = queryParams.get('type')
    const search = queryParams.get('search')
    const memberType = queryParams.get('type') || queryParams.get('memberType')
    const productSubType = queryParams.get('productSubType')
    const sort = queryParams.get('sort')
    const orderStatus = queryParams.get('orderStatus')
    const includeNoMembership = queryParams.get('includeNoMembership')
    const productOwnerId = queryParams.get('productOwnerId')
    const seasons = queryParams.get('seasons')
    const ageGroups = queryParams.get('ageGroups')
    const state = queryParams.get('state')
    const region = queryParams.get('region')
    const zone = queryParams.get('zone')
    const assoc = queryParams.get('assoc')
    const club = queryParams.get('club')
    const settlementId = queryParams.get('settlementId')
    const source = queryParams.get('source')
    const startDate = queryParams.get('startDate')
    const endDate = queryParams.get('endDate')
    const eventId = queryParams.get('eventId') || eventNumber
    const eventIds = queryParams.get('eventIds')
    const subEventIds = queryParams.get('subEventIds')
    const subEventId = queryParams.get('subEventId')
    const teamId = queryParams.get('teamId')
    const team = queryParams.get('team')
    const teamName = queryParams.get('teamName')

    const postData = {
      loggedInUser: contactId,
      orgId: organisationId || orgId,
      fileType: 'csv',
      name: exportFileName,
      directDownload: true,
      taskType: exportDataUrl.includes('members/byproduct')
        ? 'membersByProduct'
        : exportDataUrl.includes('members/byorganisation')
          ? 'membersByOrganisation'
          : exportDataUrl.includes('members/byseason')
            ? 'membersBySeason'
            : exportDataUrl.includes('members/byaddonproduct')
              ? 'membersByAddonProducts'
              : exportDataUrl.includes('members/bymembertype')
                ? 'membersByMemberType'
                : exportDataUrl.includes('members/byfinancial')
                  ? 'membersByFinancialFilter'
                  : exportDataUrl.includes('/orders')
                    ? 'ordersList'
                    : exportFileName.includes('Settlements Listing')
                      ? 'settlementsList'
                      : exportFileName.includes('settlementItemsAll')
                        ? 'settlementsItemsAll'
                        : exportDataUrl.includes('/teams')
                          ? 'teamsList'
                          : exportDataUrl.includes('/participants/byteam')
                            ? 'participantsByTeam'
                            : exportDataUrl.includes('/participants/byproduct')
                              ? 'participantsByProduct'
                              : exportDataUrl.includes('/participants/byaddonproducts')
                                ? 'participantsByAddOnProduct'
                                : 'membersList',
      status: 'Pending',
      organisationId: organisationId || orgId,
      ...(product ? { product } : {}),
      ...(productId ? { productId } : {}),
      ...(org ? { org } : {}),
      ...(gender ? { gender } : {}),
      ...(genderIdentity ? { genderIdentity } : {}),
      ...(q ? { q } : {}),
      ...(search ? { search } : {}),
      ...(sort ? { sort } : {}),
      ...(memberStatus ? { memberStatus } : {}),
      ...(productSubType ? { productSubType } : {}),
      ...(orderStatus ? { orderStatus } : {}),
      ...(includeNoMembership ? { includeNoMembership } : {}),
      ...(productOwnerId ? { productOwnerId } : {}),
      ...(seasons ? { seasons } : {}),
      ...(ageGroups ? { ageGroups } : {}),
      ...(memberType ? { memberType } : {}),
      ...(type ? { type } : {}),
      ...(state ? { state } : {}),
      ...(region ? { region } : {}),
      ...(zone ? { zone } : {}),
      ...(assoc ? { assoc } : {}),
      ...(club ? { club } : {}),
      ...(page ? { page } : {}),
      ...(size ? { size } : {}),
      ...(teamStatus ? { teamStatus } : {}),
      ...(subEventIds ? { subEventIds } : {}),
      ...(subEventId ? { subEventId } : {}),
      ...(eventIds ? { eventIds } : {}),
      ...(eventId ? { eventId } : {}),
      ...(settlementId ? { settlementId } : {}),
      ...(source ? { source } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(teamName ? { teamName } : {}),
      ...(teamId ? { teamId } : {}),
      ...(team ? { team } : {}),
    }

    const requestHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    setAlert({
      open: true,
      title: 'Export Initiated',
      variant: 'info',
      text: 'It will download to your device automatically.',
    })

    axios
      .post(
        '/api/request',
        {
          method: 'POST',
          headers: requestHeaders,
          UserAuthorization: true,
          endpointId: 'exports',
          bypassGateway: true,
          data: JSON.stringify({ ...postData, methodType: 'POST' }),
        },
        { headers: requestHeaders }
      )
      .then(response => {
        if (response.data?.success && response.data?.data?.url) {
          const { url, fileName, toastMessage } = response.data.data
          const downloadUrl = `/gamedayapi/${url}`
          fetch(downloadUrl)
            .then(res => {
              if (!res.ok) throw new Error(`Download failed: ${res.status}`)
              return res.blob()
            })
            .then(blob => {
              const blobUrl = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = blobUrl
              if (fileName) link.download = fileName
              link.style.display = 'none'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              window.URL.revokeObjectURL(blobUrl)
            })
            .catch(() => {
              setAlert({
                open: true,
                title: 'Download Error',
                variant: 'error',
                text: 'Failed to download export file. Please try again from the notification bell.',
              })
            })
          if (toastMessage) {
            setAlert({
              open: true,
              title: 'Export Notice',
              variant: 'info',
              text: toastMessage,
            })
          }
        } else if (response.data?.success && response.data?.data?.fallbackToAsync) {
          setAlert({
            open: true,
            title: 'Export Queued',
            variant: 'info',
            text: 'Export is too large to download directly. You will receive a notification in the notification bell when it is ready to download.',
          })
        } else if (response.data?.success && !response.data?.data?.url) {
          setAlert({
            open: true,
            title: 'Export Warning',
            variant: 'warning',
            text: response.data?.data?.message || 'No data to export.',
          })
        }
      })
      .catch(error =>
        setAlert({
          open: true,
          title: 'Error',
          variant: 'error',
          text: error?.message || 'Something went wrong',
        })
      )
  }

  return (
    <>
      <AlertMini
        title={alert.title}
        variant={alert.variant}
        text={alert.text}
        isNewLine={true}
        open={alert.open}
        duration={3000}
        onClose={() => setAlert(prev => ({ ...prev, open: false }))}
      />
      <ExportLink onClick={exportData} aria-label="Export" disabled={exportDisabled}>
        <StyledIconContainer>
          <Tooltip content="Export CSV">
            <ExportIcon />
          </Tooltip>
        </StyledIconContainer>
      </ExportLink>
    </>
  )
}

ExportTableData.defaultProps = {
  exportDataUrl: '',
  exportRequestHeaders: {},
  token: '',
}

export default ExportTableData
